import { useQuery } from "react-query";
import { api, ApiError } from "utils/api";
import { RaffleReportResponse } from "../types";

const getRaffleReport = (raffleId: string) => {
  const params = { raffleIds: raffleId };
  const query = new URLSearchParams(params);
  return api(`/rewards/raffle/reports?${query}`);
};

const useRaffleReport = (raffleId?: string) =>
  useQuery<RaffleReportResponse[], ApiError>(
    ["admin-report", "raffle", raffleId],
    () => getRaffleReport(raffleId as string),
    {
      enabled: !!raffleId,
    }
  );

export { useRaffleReport };
